const BASE_URL = process.env.REACT_APP_API_ENDPOINT || "";

export const config = {
  REACT_APP_GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  API_BASE_URL: `${BASE_URL}/api`,
  PROFILE_IMAGE_BASE_URL: `${BASE_URL}/api/avatars`,
};